/* global G */

import { setKey } from 'lib/util'

/**
 * Go Hook
 *
 * Gets back `count` amount of history entries.
 *
 * @param {Object} count  number of entries in the history to go back
 * @returns {function(*): function(...[*]): Promise<*[]>}
 */
const go = count => obj => async (...args) => {
  setKey(null, G.UNDO, obj[G.STATE][G.ACTION][G.STATE])
  await obj[G.ADAPTER][G.ROUTER].go(count)
  return args
}

export default go
